
import { useState } from 'react';

export default function FloatingEmail() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="fixed bottom-8 left-4 md:bottom-12 md:left-8 z-50">
      <a
        href="mailto:sunroutegroup@gmail.com"
        className="w-[50px] h-[50px] md:w-[60px] md:h-[60px] bg-[#F97316] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 hover:shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-all duration-300 cursor-pointer"
        aria-label="Send Email"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <i className="ri-mail-send-line text-white text-xl md:text-2xl"></i>
      </a>
    </div>
  );
}
